import React from 'react';

export const UnreadText = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8.83375 3C5.61218 3 2 5.5 2 10.7047C2 15 5.61269 17.4093 8.83417 17.4093H16.1667L19.186 20.7968C20.4788 21.429 22 20.5096 22 19.096V10.7047L21.9739 10.5C21.9739 6.5 18.5197 3 15.5 3L8.83375 3ZM20.3333 10.7047C20.3333 8 17.8013 4.6299 15.5 4.6299L8.83375 4.6299C6.53248 4.6299 3.66667 6.36141 3.66667 10.7047C3.66667 14.5 6.5328 15.7794 8.83417 15.7794H16.3634H16.5673L16.7361 15.8654L19.9313 19.339C20.116 19.4293 20.3333 19.096 20.3333 19.096C20.3333 19.096 20.3333 13.4093 20.3333 10.7047Z"
      fill="black"
      fillRule="evenodd"
    />
    <circle cx="21" cy="5" fill="black" r="4" stroke="white" strokeWidth="2" />
  </svg>
);
